const React = require('react');
import GoogleMapReact from 'google-map-react';

class Map extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            largeView: false
        };
    }
    setCenter(mapObj) {
        const {map, maps} = mapObj;
    }
    render() {
        const MapMarker = () => (
            <svg x="0px" y="0px" width="44px" height="44px" viewBox="0 0 44 44">
                <circle opacity="0.3" fill="#59222C" cx="22" cy="22" r="22"/>
                <circle fill="#59222C" cx="22" cy="22" r="3.3"/>
            </svg>
        );
        const {latitude, longitude} = this.props.position;
        const {address, zip, city} = this.props;
        const {largeView} = this.state;

        const map =  <GoogleMapReact
        bootstrapURLKeys={{
            key: 'AIzaSyA5fFrKr3uHkpsl5-2dktbYh2AHGaqfSsU'
        }}
        defaultCenter={{lat: parseFloat(latitude), lng: parseFloat(longitude)}}
        defaultZoom={13}
        resetBoundsOnResize={true}
        style={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0}}
        >
            <MapMarker
            lat={latitude}
            lng={longitude}
            />
        </GoogleMapReact>;

        return (
        <div className="map">
            <h2 className="map__address">{address}</h2>
            <h3 className="map__city">{zip && <span>{zip} </span>}{city && <span>{city}</span>}</h3>
            <div className="map__container">
                <div className="map__zoomBtn" onClick={() => this.setState({largeView: true})}>
                    <svg width="48" height="48" viewBox="0 0 48 48"><path fill="#4D4D4D" fill-rule="evenodd" d="M22.037 22h-11.18l2.236-2.237a2 2 0 1 0-2.828-2.828L4.62 22.58c-.395.395-.59.907-.59 1.419a1.974 1.974 0 0 0 .584 1.415l5.651 5.651a2 2 0 1 0 2.828-2.828L10.857 26h11.18v11.18L19.8 34.943a2 2 0 1 0-2.828 2.828l5.65 5.651c.393.393.904.587 1.416.584.512 0 1.023-.194 1.419-.59l5.645-5.644a2 2 0 1 0-2.828-2.828l-2.237 2.236V26h11.177l-2.237 2.237a2 2 0 1 0 2.828 2.828l5.651-5.65c.393-.393.587-.904.584-1.416 0-.512-.194-1.024-.59-1.42l-5.644-5.644a2 2 0 1 0-2.828 2.828L37.213 22H26.037V10.823l2.236 2.237a2 2 0 1 0 2.829-2.829l-5.645-5.645a1.994 1.994 0 0 0-1.419-.589 1.974 1.974 0 0 0-1.416.583l-5.65 5.651A2 2 0 1 0 19.8 13.06l2.237-2.237V22z"/></svg>
                </div>
                {map}
            </div>

            {largeView && (
            <div className="map__large-container" onClick={() => this.setState({largeView: false})}>
                <div className="map__large" onClick={(e) => e.stopPropagation()}>
                    <div className="map__closeBtn" onClick={() => this.setState({largeView: false})}>
                        <svg width="48" height="48" viewBox="0 0 48 48"><path fill="#4D4D4D" fill-rule="evenodd" d="M26 22V8c0-1.11-.895-2-2-2-1.112 0-2 .895-2 2v14H8c-1.11 0-2 .895-2 2 0 1.112.895 2 2 2h14v14c0 1.11.895 2 2 2 1.112 0 2-.895 2-2V26h14c1.11 0 2-.895 2-2 0-1.112-.895-2-2-2H26z"/></svg>
                    </div>
                    {map}
                </div>
            </div>
            )}

        </div>
        )
    }
}

module.exports = Map;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Map/index.jsx